import * as React from 'react'
import { Text, StyleSheet } from 'react-native'
import { black, COLOR_969dad } from '@themes/Colors'
import Fonts from '@themes/Fonts'
import type { RouteWithSceneType } from './types'

type Props = {
  focused: boolean
  route: RouteWithSceneType
}

export function TabLabel(props: Props) {
  return (
    <Text style={[styles.label, !props.focused && styles.labelInactive]}>
      {props.route.title}
    </Text>
  )
}

const styles = StyleSheet.create({
  label: {
    userSelect: 'none',
    color: black,
    fontFamily: Fonts.type.gilroyBold,
    fontSize: Fonts.size.regular,
    fontWeight: 'bold',
  },
  labelInactive: {
    color: COLOR_969dad,
  },
})
